import {Dispatch, SetStateAction, useEffect} from "react";
import {PcsSearchParamType} from "../interface";
import {SubmitHandler, useForm} from "react-hook-form";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import moment from "moment";

interface PropsType {
    searchParam: PcsSearchParamType
    setSearchParam: Dispatch<SetStateAction<PcsSearchParamType>>
    menuTitleText: string
    urlText: string
    isPcsDelivery?: boolean
    isOrderRequest?: boolean
}

export default function Filter({
                                   searchParam,
                                   setSearchParam,
                                   menuTitleText,
                                   urlText,
                                   isPcsDelivery,
                                   isOrderRequest
                               }: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<PcsSearchParamType> = (submitData) => {
        goToNavigation(`${urlText}/list?pageNo=1`, {}, false)
        setSearchParam({...submitData, pageNo: 1});
    };

    // 상태 변경 시 필드 초기화 및 searchParam 업데이트
    useEffect(() => {
        const defaultFromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
        const defaultToDate = moment().add().format("YYYY-MM-DD")

        setValue("purchaseOrderState", "0");
        setValue("fromDate", defaultFromDate);
        setValue("toDate", defaultToDate);

        setSearchParam(prev => ({
            ...prev,
            purchaseOrderState: "0",
            fromDate: defaultFromDate,
            toDate: defaultToDate,
        }));
    }, [isPcsDelivery, isOrderRequest, setValue, setSearchParam]);

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">{menuTitleText}검색</h3>
            <div className="filter_toolbar"></div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <select className="form-select w-150px"
                            value={watch("purchaseOrderState")}
                            {...register("purchaseOrderState")}
                    >
                        {isPcsDelivery && <>
                            <option value={"0"}>전체</option>
                            <option value={"1"}>출하</option>
                            <option value={"2"}>납품</option>
                        </>}
                        {isOrderRequest && <>
                            <option value={"0"}>전체</option>
                            <option value={"1"}>수주요청</option>
                            <option value={"2"}>수주요청완료</option>
                        </>}
                        {!isPcsDelivery && !isOrderRequest && <>
                            <option value={"0"}>전체</option>
                            <option value={"1"}>발주요청</option>
                            <option value={"2"}>발주완료</option>
                        </>}
                    </select>
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor=""
                           className="form-label frm_label">{menuTitleText === "납품 " ? "발주 " : menuTitleText}일자</label>
                    <div className="frm_field input_date">
                        <input type="date" className="form-control"
                               max="9999-12-31"
                               {...register("fromDate")}
                        />
                        <span className="txt_range">~</span>
                        <input type="date" className="form-control me-0"
                               max="9999-12-31"
                               {...register("toDate")}
                        />
                        <button className="btn btn-info btn_search">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
}